export enum FieldHistoryOverviewDatasets {
  GROUP = 'group',
  CROP = 'crop',
  BREED = 'breed',
  YIELD = 'yield',
}
